import { useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography
} from '@mui/material'
import css from './ModalFotoPerfil.module.css'

const ModalFotoPerfil = ({ open, foto, isLoading, onClose, onSubmit }) => {
  const [file, setFile] = useState(null)
  const [preview, setPreview] = useState(null)

  useEffect(() => {
    if (!open) {
      setFile(null)
      setPreview(null)
      return
    }
    if (foto) setPreview(foto)
  }, [foto, open])

  const handleFileChange = event => {
    const file = event.target?.files[0]
    if (!file) return
    setFile(file)
    setPreview(URL.createObjectURL(file))
  }

  const handleSubmit = () => onSubmit(file)

  const isSubmitDisabled = isLoading || !file

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
      <DialogTitle>Sube tu foto de perfil</DialogTitle>
      <DialogContent className={css.main}>
        <Typography variant='body2' className={css.warning}>
          Tu foto de perfil será visible en Classfy si eres un docente que esté
          dando clase en la plataforma.
        </Typography>
        <div className={css.intro}>
          {preview ? (
            <img src={preview} alt='Preview' className={css.preview} />
          ) : (
            <i className={`material-icons ${css.placeholder}`}>
              account_circle
            </i>
          )}
          <Button component='label'>
            {preview ? 'Cambiar foto' : 'Seleccionar foto'}
            <input
              type='file'
              accept='image/*'
              onChange={handleFileChange}
              hidden
            />
          </Button>
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          disabled={isSubmitDisabled || isLoading}
          color='primary'
          onClick={handleSubmit}
          startIcon={isLoading && <CircularProgress size={12} />}
        >
          Subir
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalFotoPerfil
